import { Trans } from "@lingui/macro"
import type { IconsId } from "@silversea-ssc/design-system-icons"
import { Button } from "@silversea-ssc/ui-components-react"
import clsx from "clsx"
import React, { ComponentPropsWithoutRef, useCallback, useState } from "react"
import SuiteFeatures from "../../ShipDetails/SuiteFeatures"
import SuiteCategories from "../../ShipDetails/SuiteCategories"
import styles from "./DeckPlanLegend.module.scss"

type Props = ComponentPropsWithoutRef<typeof SuiteCategories>

const DeckPlanLegend: React.FC<Props> = (props) => {
    const [expanded, setExpanded] = useState(false)
    const id = "deck-plan-legend"
    const buttonId = `button-${id}`
    const containerId = `container-${id}`
    const icon: IconsId = expanded ? "chevron-up" : "chevron-down"

    const onClick = useCallback(() => setExpanded(!expanded), [expanded])

    return (
        <div className={styles.legendContainer}>
            <Button
                renderAs="button"
                id={buttonId}
                variant="secondary"
                full
                iconName={icon}
                aria-expanded={expanded}
                aria-controls={containerId}
                onClick={onClick}
                className={styles.header}
                dataContentPiece="deck_plan_legend"
            >
                <Trans>Deck plan legend</Trans>
            </Button>
            <div
                id={containerId}
                aria-labelledby={buttonId}
                role="region"
                className={clsx(styles.content, {
                    [styles.contentExpanded]: expanded,
                })}
                data-content-piece="details_button"
            >
                <div className={styles.section}>
                    <SuiteCategories {...props} />
                </div>
                <div className={styles.section}>
                    <SuiteFeatures />
                </div>
            </div>
        </div>
    )
}

export default DeckPlanLegend
